import { Container, Layout } from "@certn/cascadia-react";
import qs from "qs";
import { useEffect } from "react";
import { Route, Routes } from "react-router";
import { useNavigate } from "react-router-dom";

import { AppFooter } from "../components/AppFooter";
import { AppHeader } from "../components/AppHeader";
import { PageNotFoundError } from "../components/PageNotFoundError";
import { DashboardPage } from "../pages/dashboard/DashboardPage";
import { NotificationsPage } from "../pages/settings/NotificationsPage";
import { HelpPrivacyPage } from "../pages/settings/help-and-privacy/HelpPrivacyPage";
import { PersonalInfoPage } from "../pages/settings/personal-info/PersonalInfoPage";
import { PreferencesPage } from "../pages/settings/preferences/PreferencesPage";

export function AppRoutes() {
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });

    if (typeof queryParams.applicantId === "string") {
      navigate(`/apply/${queryParams.applicantId}`);
    }
  });

  return (
    <Layout
      layout="applicant/narrow"
      header={<AppHeader />}
      footer={<AppFooter />}
    >
      <Container>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route
            path="/settings/personal-info"
            element={<PersonalInfoPage />}
          />
          <Route path="/settings/preferences" element={<PreferencesPage />} />
          <Route
            path="/settings/notifications"
            element={<NotificationsPage />}
          />
          <Route
            path="/settings/help-and-privacy"
            element={<HelpPrivacyPage />}
          />
          <Route path="*" element={<PageNotFoundError />} />
        </Routes>
      </Container>
    </Layout>
  );
}
